import { EditorSubType } from '@wix/editor-platform-sdk-types';

import { resolveEditorComponent } from '../../../resolveEditorComponent';

export type BoxShadowPreviewProps = {
  value: string;
  isMixed?: boolean;
  disabled?: boolean;
  emptyPreviewLabel: string;
};

export default resolveEditorComponent({
  default: () => import('./variants/DefaultBoxShadowPreview'),
  overrides: {
    [EditorSubType.Studio2]: () => import('./variants/Studio2BoxShadowPreview'),
  },
});
